<template>
  <nav :class="$mq" v-if="navIsShown">
    <div @click="changeGif('musicIN')" class="nav-item music" :class="$mq">
      <span>music</span>
    </div>
    <div class="nav-item video" :class="$mq">
      <span>video</span>
    </div>
    <div class="icon fb" :class="$mq">
      <Fb></Fb>
    </div>
    <div class="nav-item gigs" :class="$mq">
      <span>gigs</span>
    </div>
    <div class="icon mail" :class="$mq">
      <Mail></Mail>
    </div>
    <div class="nav-item ilhem" :class="$mq">
      <span>ilhem</span>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Nav',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Nav.vue